module.exports = __webpack_public_path__ + "static/media/u1b_7.cb81e45d.mp3";